import type { Locale } from '../i18n';

export const HOME_FAQS: Record<Locale, { q: string; a: string }[]> = {
  fr: [
    {
      q: 'Codex est-elle une entreprise de développement logiciel en Algérie ?',
      a: 'Oui. Codex (SARL Groupe Codex) est un studio logiciel et une agence IT indépendante basée à Alger, fondée en 2014. Nous concevons des logiciels sur mesure, des applications web et mobiles, du cloud et de la cybersécurité.',
    },
    {
      q: 'Quels services propose Codex en Algérie ?',
      a: 'Développement logiciel sur mesure, sites et applications web, apps mobiles (iOS et Android avec React Native), cloud et DevOps, data analytics et cybersécurité — pour clients en Algérie et à l’international.',
    },
    {
      q: 'Où se situe Codex ?',
      a: 'Notre studio est à Alger (Djasr Kasentina / Ain Malha). Nous travaillons avec des équipes en Algérie, en Afrique, en Europe et au Moyen-Orient en français, arabe et anglais.',
    },
    {
      q: 'Codex participe-t-elle à des salons et expositions ?',
      a: 'Oui. Codex a participé à de nombreux événements, notamment Web Expo, Web Summit, Algeria Export Fair et AFES — pour rencontrer clients, partenaires et l’écosystème digital.',
    },
    {
      q: 'Avez-vous des produits prêts (pas seulement du sur-mesure) ?',
      a: 'Oui. Codex propose des bases produits prêtes à personnaliser : VTC, food delivery, Flexy / recharge, et e-learning — plus rapides à lancer qu’un build from scratch. Demandez une démo via /fr/devis.',
    },
    {
      q: 'Comment obtenir un devis chez Codex ?',
      a: 'Utilisez le configurateur sur codexalgerie.com/fr/devis pour choisir type, plateformes et options, ou contactez-nous via WhatsApp / email contact@codexalgerie.com (+213 550 35 77 36).',
    },
    {
      q: 'Comment contacter Codex pour un projet ?',
      a: 'Email contact@codexalgerie.com, téléphone +213 550 35 77 36, WhatsApp, le devis interactif (/fr/devis), ou le formulaire de contact sur le site.',
    },
  ],
  en: [
    {
      q: 'Is Codex a software development company in Algeria?',
      a: 'Yes. Codex (SARL Groupe Codex) is an independent software studio and IT agency based in Algiers, Algeria, founded in 2014. We build custom software, web and mobile apps, cloud platforms and cybersecurity solutions.',
    },
    {
      q: 'What services does Codex Algeria offer?',
      a: 'Custom software development, web development, mobile apps (iOS and Android with React Native), cloud and DevOps, data analytics, and cybersecurity — for clients in Algeria and internationally.',
    },
    {
      q: 'Where is Codex located?',
      a: 'Our studio is in Algiers (Djasr Kasentina / Ain Malha area). We work with teams across Algeria, Africa, Europe and the Middle East in French, Arabic and English.',
    },
    {
      q: 'Does Codex participate in expos and summits?',
      a: 'Yes. Codex has taken part in many events including Web Expo, Web Summit, Algeria Export Fair and AFES — meeting clients, partners and the digital ecosystem.',
    },
    {
      q: 'Do you offer ready-made products (not only custom builds)?',
      a: 'Yes. Codex has product bases you can brand and adapt: VTC, food delivery, Flexy / top-up, and e-learning — faster than starting from zero. Request a demo via /en/devis.',
    },
    {
      q: 'How do I get a quote from Codex?',
      a: 'Use the project configurator at codexalgerie.com/en/devis to pick type, platforms and options, or reach us on WhatsApp / email contact@codexalgerie.com (+213 550 35 77 36).',
    },
    {
      q: 'How can I contact Codex for a project?',
      a: 'Email contact@codexalgerie.com, call +213 550 35 77 36, WhatsApp, the quote tool (/en/devis), or the contact form on the site.',
    },
  ],
  ar: [
    {
      q: 'هل كودكس شركة تطوير برمجيات في الجزائر؟',
      a: 'نعم. كودكس (SARL Groupe Codex) استوديو برمجيات ووكالة تقنية مستقلة في الجزائر العاصمة منذ 2014. نبني برمجيات مخصصة وتطبيقات ويب وموبايل وسحابة وأمنًا سيبرانيًا.',
    },
    {
      q: 'ما الخدمات التي تقدمها كودكس؟',
      a: 'تطوير برمجيات مخصصة، مواقع وتطبيقات ويب، تطبيقات موبايل (iOS وAndroid مع React Native)، سحابة وDevOps، تحليلات بيانات وأمن سيبراني — في الجزائر ودوليًا.',
    },
    {
      q: 'أين يقع مقر كودكس؟',
      a: 'الاستوديو في الجزائر العاصمة (جسر قسنطينة / عين مالحة). نعمل بالعربية والفرنسية والإنجليزية عبر الجزائر وأفريقيا وأوروبا والشرق الأوسط.',
    },
    {
      q: 'هل تشارك كودكس في معارض وفعاليات؟',
      a: 'نعم. شاركت كودكس في العديد من الفعاليات منها Web Expo وWeb Summit وAlgeria Export Fair وAFES — للقاء العملاء والشركاء ومنظومة الرقمنة.',
    },
    {
      q: 'هل لديكم منتجات جاهزة وليس البناء المخصص فقط؟',
      a: 'نعم. لدى كودكس قواعد منتجات للتخصيص: VTC وتوصيل طعام وFlexy / شحن رصيد والتعليم الإلكتروني — أسرع من البناء من الصفر. اطلبوا عرضًا عبر /ar/devis.',
    },
    {
      q: 'كيف أحصل على عرض سعر من كودكس؟',
      a: 'استخدم مكوّن التقدير على codexalgerie.com/ar/devis لاختيار النوع والمنصات والخيارات، أو تواصل عبر واتساب / البريد contact@codexalgerie.com (+213 550 35 77 36).',
    },
    {
      q: 'كيف أتواصل مع كودكس لمشروع؟',
      a: 'البريد contact@codexalgerie.com أو الهاتف +213 550 35 77 36 أو واتساب أو /ar/devis أو نموذج التواصل على الموقع.',
    },
  ],
};
